<template>
  <div class="fill-height" :id="[$globalConfig.APP_NAME === 'partner' ? 'partnerHub' : '']">
    <Header></Header>
    <release-notes-dialog ref="rn" />
    <Navigation v-show="isLoggedIn"></Navigation>
    <Breadcrumb v-if="isLoggedIn" />
    <slideout-panel></slideout-panel>
    <slot />
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/HeaderPartner";
import Breadcrumb from "@/components/Breadcrumb";
import Navigation from "@/components/PartnerHubNavigation";
import Footer from "@/components/Footer";
import ReleaseNotesDialog from '@/components/ReleaseNotesDialog.vue';
export default {
  name: "LayoutBasic",
  components: {
    Header,
    Navigation,
    Footer,
    Breadcrumb,
    ReleaseNotesDialog
  },
  mounted() {
    // if (window.fcWidget) {
    //   window.fcWidget.hide();
    // }
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    }
  }
};
</script>

<style media="screen">
.basic-layout {
  padding-bottom: 32px;
}
</style>
